import React, {Component} from 'react';
import styled from 'styled-components';
import Parser from "html-react-parser";
import {media, mixins} from "../../mixins";
import H from "../typography/H";

const Image = styled.div`
  grid-column-start: 1;
  grid-column-end: 11;
  grid-row: 1;
  padding-bottom: 80px;
  img{
    width: 100%;
  }
  &.reversed{
    grid-column-start: 4;
    grid-column-end: 15;
  }
`;

const Card = styled.div`
  grid-column-start: 8;
  grid-column-end: 14;
  grid-row: 1;
  //height: 100%;
  align-self: end;
  padding: 40px;
  margin-left: -40px;
  background-color: ${p => p.theme.cCard};
  &.reversed{
    grid-column-start: 2;
    grid-column-end: 8;
  }
`;

const Title = styled.section`
  padding-bottom: 60px;
  position: relative;
  &:after{
    ${mixins.pseudoToBlock()};
    width: 30px;
    height: 7px;
    position: absolute;
    left: 0;
    bottom: 25px;
    background-color: ${p => p.theme.cTheme};
  }
`;


const Text = styled.section`
  
`;

class TextBlock extends Component {
    render() {

        const block = this.props.block;

        return (
            <div className={this.props.className}>
                <Image className={block.mods && block.mods.reversed ? 'reversed' : ''}>
                    <img alt={block['image_alt']} src={block.image}/>
                </Image>
                <Card className={block.mods && block.mods.reversed ? 'reversed' : ''}>
                    <Title>
                        <H size={2} styleSize={2}>{block.title}</H>
                    </Title>
                    <Text>
                        {Parser(block.text)}
                    </Text>
                </Card>
            </div>
        );
    }
}
// export default styled(TextBlock)``;

export default styled(TextBlock)`
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: 1fr repeat(12, calc(((${p => p.theme.xl}px - (13 * 20px))/12))) 1fr;
  max-width: 1180px;
  margin: auto;
  padding-bottom: 80px;
  ${media.lg`
    grid-template-columns: 1fr repeat(12, calc(((${p => p.theme.lg}px - (13 * 20px))/12))) 1fr;
  `}
  ${media.md`
    grid-template-columns: 1fr repeat(12, calc(((${p => p.theme.md}px - (13 * 20px))/12))) 1fr;
  `}
  ${media.sm`
    grid-template-columns: 1fr repeat(12, calc(((${p => p.theme.sm}px - (7 * 20px))/6))) 1fr;
  `}
`;
